import { useMemo } from 'react'
import { useIntlDateFormatter, useIntlDateRangeFormatter } from 'lib/datetime/dateUtils'
import type { TripDateFormatters } from './orderTileDisplayUtils'

export function useTripDateFormatters(): TripDateFormatters {
  const formatDate = useIntlDateFormatter()
  const formatDateRange = useIntlDateRangeFormatter()
  return useMemo(() => ({ formatDate, formatDateRange }), [formatDate, formatDateRange])
}
